'use client';

import * as React from 'react';

import { Dashboard } from '@/shared/i18n';
import { ContentsSection } from '../shared';
import { initialPagination } from '../../utils/pagination';
import { useDashboardStore } from '../../store/dashboard-store';
import { DashboardEventKeys, DashboardEvents } from '../../events';
import { EventBus } from '@/shared/utils';
import { formatDuration } from '../../utils/return-duration-from-seconds';

interface TrendingSeriesProps {
  hasModal: boolean;
  dict: Dashboard;
  eventBus: EventBus<DashboardEvents>;
}

const TrendingSeries: React.FC<TrendingSeriesProps> = ({ hasModal, dict, eventBus }) => {
  const { trendingSeries } = useDashboardStore();

  React.useEffect(() => {
    if (!trendingSeries?.data?.data)
      eventBus.emit(DashboardEventKeys.trendingSeries.view, initialPagination);
  }, [trendingSeries?.data?.data, eventBus]);

  return (
    <ContentsSection
      isLoading={trendingSeries.status.isLoading}
      isError={trendingSeries.status.isError}
      title="Serie di tendenza"
      fetchMore={(page, pageSize) =>
        eventBus.emit(DashboardEventKeys.trendingSeries.view, { page, pageSize })
      }
      pagination={trendingSeries?.data?.pagination}
      data={
        trendingSeries?.data?.data?.map((el) => ({
          documentId: el?.documentId,
          courseType: 'Serie',
          title: el?.title,
          isCourseStarted: false,
          imageSrc: el?.thumbnail?.url || '/assets/images/video-play.svg',
          description: el?.description || null,
          duration: formatDuration(el?.duration || 0),
          level: el.skillLevel?.name,
          videoCount: el?.numberOfVideos,
          trailerPlaybackId: el?.trailerPlaybackId || null,
          trailerPlaybackToken: el?.trailerPlaybackToken || null,
          lessons: el?.lessons,
          genres: el?.musicalGenres?.map((t) => t.name || ''),
          instructors:
            el?.teacherProfiles?.map((tp) => ({
              name: tp?.displayName,
              avatarUrl: tp?.profilePicture?.url,
            })) || [],
        })) || []
      }
      onCardClickCallback={(item) => null}
      hasNavigationButtons={
        !!trendingSeries?.data?.data?.length && trendingSeries?.data?.data?.length > 3
      }
      hasModal={hasModal}
      type="slider"
      dict={dict}
      eventBus={undefined}
    />
  );
};
export default TrendingSeries;
